import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataProtectionNoticeEndpoint } from '../constants/data-protection-notice-endpoint';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { HttpHeaders } from '@angular/common/http';
import { RequestHeader } from '../../../../constants';

@Injectable({
  providedIn: 'root',
})
export class DataProtectionNoticeCountriesListService {
  constructor(private http: WrapperHttpService) {}

  getDpnCountriesList(): Observable<string[]> {
    const url = `${API_URL}${DataProtectionNoticeEndpoint.Base}${DataProtectionNoticeEndpoint.Public}${DataProtectionNoticeEndpoint.Country}`;
    return this.http.withLoading().get<string[]>(url, {
      headers: new HttpHeaders({
        [RequestHeader.SkipInterceptor]: '',
      }),
    });
  }
}
